import { useEffect, useRef, useState } from 'react';
import { publicApi } from '@/lib/api';

const CHECK_INTERVAL = 60000; // Check every 60s

export function useVersionCheck() {
  const [hasUpdate, setHasUpdate] = useState(false);
  const lastVersion = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await publicApi.getVersion();
        const version = res.data?.version;
        if (!version) return;
        
        if (lastVersion.current === null) {
          lastVersion.current = version;
        } else if (lastVersion.current !== version) {
          setHasUpdate(true);
        }
      } catch (e) {
        // console.warn('Version check failed:', e);
      }
    };

    check();
    const interval = setInterval(check, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const refresh = () => {
    window.location.reload();
  };

  const dismiss = () => {
    setHasUpdate(false);
    lastVersion.current = null; // Reset so next check gets fresh version
  };

  return { hasUpdate, refresh, dismiss };
}
